import React from 'react';
import { ThemeProvider } from '@material-ui/core';

import { theme } from './index';

const themeDecorator = (el: React.ReactNode): React.ReactNode => (
  <ThemeProvider theme={theme}>{el}</ThemeProvider>
);
export { themeDecorator };
